module.exports = __webpack_public_path__ + "img/screen-shot-2020-06-19-at-14-removebg-preview@2x.9773b187.png";